import { ComponentChildren, h } from 'preact';
import styled from 'styled-components';
import { breakpoints } from './variables';

type Variant = 'primary' | 'headline1' | 'headline3' | 'body1' | 'body2' | 'body3';
type FontWeight = 'normal' | 'bold';

const variantStyles = (variant = 'primary') =>
	({
		headline1: `
			font-family: 'Bowlby One';
			font-style: normal;
			font-weight: normal;
			font-size: 24px;
			line-height: 34px;

			@media screen and (min-width: ${breakpoints.md}) {
				font-size: 34px;
				line-height: 40px;
			}
		`,
		headline3: `
			font-family: 'Nunito Sans';
			font-size: 18px;
			font-style: normal;
			font-weight: 700;
			line-height: 22px;
		`,

		body1: `
			font-family: 'Nunito Sans';
			font-style: normal;
			font-weight: normal;
			font-size: 16px;
		`,
		body2: `
			font-family: 'Nunito Sans';
			font-style: normal;
			font-weight: normal;
			font-size: 14px;
		`,
		body3: `
			font-family: Nunito Sans;
			font-style: normal;
			font-weight: normal;
			font-size: 12px;
		`,
		primary: `
			color: 'red';
		`,
	}[variant]);

const TypographyStyled = styled.div<{ variant: Variant; weight?: FontWeight }>`
	${({ variant }) => variantStyles(variant)}
	${({ weight }) => weight && `font-weight: ${weight}`}
`;

interface TypographyInterface {
	variant?: Variant;
	weight?: FontWeight;
	children: ComponentChildren;
}

export const Typography = ({ variant = 'primary', weight, children }: TypographyInterface) => (
	<TypographyStyled as="div" variant={variant} weight={weight}>
		{children}
	</TypographyStyled>
);
